// src/controllers/dosije_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["select", "submit", "scrolltop"]

    initialize() {
        this.element.querySelectorAll('input:not([name]), select:not([name])').forEach(field => {
            field.classList.add('bg-gray-100')
            field.disabled = true
        })
    }

    selectNewItem(event) {
       this.scrolltopTarget.value = event.target.getBoundingClientRect().top + window.scrollY - 100;
       this.submitTarget.click()
    }
}